module.exports = __webpack_public_path__ + "static/media/marriage-2.15d51b30.jpg";